import { defineBlock, smartProps, useInspectorControl, useEditor } from '@smartfire/js-block-engine';
import { EditableText } from '@smartfire/components';
import { useState, lazy } from 'react';
import style from './block.module.scss';
import apiFetch from '@wordpress/api-fetch';
import { ReactComponent as Arrow } from '../assets/arrow.svg';
import { ReactComponent as Decoration } from '../assets/decoration.svg';
import clsx from 'clsx';

const Inspector = lazy(() => import('./Inspector'));

const FormCollectData = ({ categorie, linkFile, buttonText, checkBoxText, background }) => {
    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState(false);
    const [successMessage, setSuccessMessage] = useState(false);

    const { isEditing } = useEditor();
    useInspectorControl(Inspector);

    const updateField = (e) => {
        setEmail(e.target.value);
    };

    const registerInformations = (e) => {
        e.preventDefault();
        setErrorMessage(false);
        setSuccessMessage(false);
        if (isEditing) return;

        apiFetch({
            path: '/smartfire/v1/addData',
            method: 'POST',
            data: {
                email: email,
                categorie: categorie,
            },
        }).then(
            (res) => {
                if (linkFile) {
                    const tagDownload = document.createElement('a');
                    tagDownload.href = linkFile;
                    tagDownload.download = categorie + ' MDH';
                    tagDownload.click();
                    tagDownload.remove();
                }
                setSuccessMessage(true);
            },
            (err) => {
                console.log('API error:', err.message);
                setErrorMessage(true);
            },
        );
    };

    return (
        <div className={style.formCollectDataContainer}>
            <div
                className={style.background}
                style={{ backgroundImage: background ? 'url(' + background.url + ')' : '' }}
            />
            <Decoration className={clsx(style.decoration, style.decorationLeft)} />
            <Decoration className={clsx(style.decoration, style.decorationRight)} />
            <div className={style.formCollectData}>
                <EditableText
                    tagName={'h2'}
                    smartProp={'title'}
                    placeholder={'Ajoutez le titre'}
                    allowedFormats={['core/bold', 'core/italic', 'core/link', 'core/text-color']}
                    className={style.title}
                />

                <form className={style.form} onSubmit={registerInformations} id="registerInfos">
                    <div className={style.firstPart}>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => updateField(e)}
                            placeholder="VOTRE EMAIL*"
                            className={style.emailInput}
                            required
                        />
                        <button type="submit" form="registerInfos" className={style.submitInput}>
                            {buttonText} <Arrow />
                        </button>
                    </div>
                    <div className={style.secondPart}>
                        <input type="checkbox" id="form_personnal_data" name="personnal_data" required />
                        <label for="form_personnal_data">
                            {checkBoxText} <p>* Champs obligatoires</p>
                        </label>
                    </div>
                </form>
                {errorMessage && (
                    <p className={style.errorMessage}>
                        Une erreur a été rencontrée vérifiez que tout les champs sont remplis
                    </p>
                )}
                {successMessage && <p className={style.successMessage}>Adresse mail envoyée avec succès</p>}
            </div>
        </div>
    );
};

export default defineBlock({
    Block: FormCollectData,
    smartProps: {
        categorie: smartProps.string.withDefault(''),
        linkFile: smartProps.string.withDefault(''),
        buttonText: smartProps.string.withDefault('Télécharger'),
        checkBoxText: smartProps.string.withDefault(''),
        background: smartProps.image,
        title: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Formulaire collecte données',
    },
});
